/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
/**
 * Check if a given object implements the Totals interface.
 */
export function instanceOfTotals(value) {
    return true;
}
export function TotalsFromJSON(json) {
    return TotalsFromJSONTyped(json, false);
}
export function TotalsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'countImpressions': json['CountImpressions'] == null ? undefined : json['CountImpressions'],
        'countUniquePlayers': json['CountUniquePlayers'] == null ? undefined : json['CountUniquePlayers'],
        'durationS': json['DurationS'] == null ? undefined : json['DurationS'],
    };
}
export function TotalsToJSON(json) {
    return TotalsToJSONTyped(json, false);
}
export function TotalsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'CountImpressions': value['countImpressions'],
        'CountUniquePlayers': value['countUniquePlayers'],
        'DurationS': value['durationS'],
    };
}
